import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.c_soil_test_uploads.a_new, .c_soil_test_uploads.a_create', () => {
  import('./internal/c_soil_test_uploads__a_new__c_soil_test_uploads__a_create').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.soil-test-form', () => {
  import('./internal/soil-test-form').then(({ default: Component }) => Component());
});
